(function () {
    'use strict';

    angular
        .module('iMatApp')
        .directive('number', numberDirective);

    numberDirective.$inject = ['utils'];
    function numberDirective(utils) {
        // Usage:
        // <input number [precision="2"] [multiplier="0.5"] >
        // 
        //
        var directive = {
            link: link,
            require: 'ngModel',
            restrict: 'A',
            scope: {
                precision: '@?precision',
                multiplier: '@?'
            }
        };
        return directive;

        function link(scope, element, attrs, ngModel) {
            var precision = 0;
            var multiplier = 1.0;

            if (angular.isDefined(scope.precision)) {
                precision = parseInt(scope.precision, 10);
            }

            if (angular.isDefined(scope.multiplier)) {
                multiplier = parseFloat(scope.multiplier);
            }

            element.on("keypress", function (event) {
                var isDigit = event.charCode >= 48 && event.charCode <= 57;
                var isDelimeterAllowed = precision >= 1 && !hasDecimal(ngModel.$viewValue);
                var isDecimalDelimiter = event.charCode === 46;

                return isDigit || (isDelimeterAllowed && isDecimalDelimiter);
            });

            element.on("blur", function () {
                ngModel.$viewValue = normalizeNumberString(ngModel.$viewValue);
                ngModel.$render();
            });

            scope.$on('$destroy', function () {
                element.off("keypress");
            });

            ngModel.$formatters.push(function (modelValue) {
                var viewValue = utils.round(modelValue * multiplier, precision);
                return viewValue.toString();
            });

            ngModel.$parsers.push(function (viewValue) {
                var value = parseFloat(viewValue);

                var transformedValue = utils.round(value, precision);
                if (transformedValue !== viewValue) {
                    ngModel.$setViewValue(transformedValue.toString());
                    ngModel.$render();
                }


                var mathlog10 = function (x) { return Math.log(x) / Math.LN10; };

                var precisionWithMultiplier = precision + mathlog10(multiplier);
                var modelValue = utils.round(value / multiplier, precisionWithMultiplier);
                return modelValue;
            });
        }

        function normalizeNumberString(numberString) {
            if (!numberString) {
                return numberString;
            }

            numberString = numberString.toString();

            var firstDelimiterIndex = numberString.indexOf(".");
            if (firstDelimiterIndex === 0) {
                return normalizeNumberString(numberString.slice(1));
            }

            var lastDelimiterIndex = numberString.lastIndexOf('.');
            if (lastDelimiterIndex === numberString.length - 1) {
                return normalizeNumberString(numberString.slice(0, -1));
            }

            return numberString;
        }

        function hasDecimal(numberString) {
            return numberString.indexOf(".") !== -1;
        }
    }

})();